let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Y0v2")).then(() => parcelRequire('dlLcW'));